import GiftCardsAndPromotions from './gift-cards-and-promotions'

export default GiftCardsAndPromotions
